module.exports = __webpack_public_path__ + "static/media/background-small.d1513215.jpg";